import React, { useEffect, useState } from 'react';
import { CustomCollapseCard, CustomImage, Text } from '@src/components';
import { Radio, Modal, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
    deleteUnCompleted,
    getCurrentCardOrder,
    setCurrentCardOrder,
} from '@src/store/slice/cardOrderSlice';
import { cardImagesGetByVouId } from '@src/store/slice/cardImagesSlice';
import '@src/styles/cardOrder/cardTypeCompliment.scss';
import { setLoadingState } from '@src/store/slice/appSettingsSlice';
import iconInfo from '@src/assets/icons/icon-bilgi.svg';
import imgGreen from '@src/assets/icons/img_green.svg';
import { warningDialog } from '@src/components/CustomDialog';
import { resetDetail } from '@src/store/slice/cardOrderDetailtsSlice';
import Lottie from 'lottie-react';
import cardTypeAnimation from '@src/assets/icons/cardTypeAnimation.json';
import PropTypes from 'prop-types';
import npGreen from '@src/assets/icons/np_green.svg';

const CardType = ({ vouId, CardDigitalSrc, fizikselImgSrc, bankCardLogoClass1, bankCardLogoClass2 }) => {
    const { currentCardOrder } = useSelector((state) => state?.cardOrder);
    const getCurrentLanguage = () => localStorage.getItem('language')?.slice(1, -1);

    const isEnglishLanguage = () => getCurrentLanguage() === 'en';
    const isEnglish = isEnglishLanguage();
    const [digitalCard, setDigitalCard] = useState(true);
    const [clickedType, setClickedType] = useState(false);
    const [showFizikselCardModal, setShowFizikselCardModal] = useState(false);
    const [dontShowAgain, setDontShowAgain] = useState(false);
    const dispatch = useDispatch();

    useEffect(async () => {
        if (currentCardOrder?.cardType === undefined) return;
        if (currentCardOrder?.cardType !== undefined && !clickedType) {
            setDigitalCard(currentCardOrder?.cardType === 0 ? false : true);
        }
    }, [currentCardOrder]);

    useEffect(() => {
        if (currentCardOrder?.vouId) {
            dispatch(cardImagesGetByVouId(currentCardOrder?.vouId));
        }
    }, [currentCardOrder]);

    useEffect(() => {
        if (currentCardOrder?.id !== 0 && !clickedType) {
            setDigitalCard(currentCardOrder?.cardType === 0 ? false : true);
        } else if (currentCardOrder?.cardType !== (digitalCard ? 1 : 0)) {
            changeType(digitalCard ? 1 : 0);
        }
    }, [digitalCard]);

    const changeType = async (cardTypeValue) => {
        try {
            dispatch(setLoadingState(true));

            await dispatch(deleteUnCompleted({ vouId }));
            await dispatch(resetDetail());
            await dispatch(getCurrentCardOrder({ vouId }));
            await dispatch(setCurrentCardOrder({ cardType: cardTypeValue }));
        } catch (e) {
            console.error('error', e);
        } finally {
            dispatch(setLoadingState(false));
        }
    };

    const clickChangeCard = () => {
        const storedName = localStorage.getItem('ShowFizikselCardModal');
        if (digitalCard && !dontShowAgain && storedName !== 'true') {
            setShowFizikselCardModal(true);
        } else {
            showWarningDialog(1);
        }
    };

    const goOnDigital = () => {
        setShowFizikselCardModal(false);
    };

    const goToFizik = async () => {
        setShowFizikselCardModal(false);
        showWarningDialog(2);
    };

    const clickDontShow = () => {
        showWarningDialog(3);
    };

    const value = currentCardOrder?.cardType;

    const clickChangeType = async (stateChangeType) => {
        if (stateChangeType === 1) {
            setDigitalCard(!digitalCard);
            setClickedType(true);
        } else if (stateChangeType === 2) {
            if (digitalCard) {
                await changeType(0);
            }
            setDigitalCard(!digitalCard);
        } else if (stateChangeType === 3) {
            localStorage.setItem('ShowFizikselCardModal', 'true');
            setShowFizikselCardModal(false);
            setDigitalCard(!digitalCard);
            setDontShowAgain(!dontShowAgain);
        }
    };

    const showWarningDialog = (stateChangeType) => {
        if (!currentCardOrder?.id) {
            clickChangeType(stateChangeType);
            return;
        }
        warningDialog({
            title: <Text t="attention" />,
            htmlContent: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <p className="gift-cancel-order-text">
                        <Text t="whenYouLeaveThisPageTheInformationYou4" />
                    </p>{' '}
                    <p className="gift-cancel-order-text">
                        <Text t="areYouSureYouWantToContinue" />
                    </p>
                    <button
                        type="button"
                        className="utts-ok-button gift-cancel-order-confirm"
                        onClick={() => clickChangeType(stateChangeType)}
                    >
                        <Text t="leavePage" />
                    </button>
                    <button type="button" className="utts-cancel-button gift-cancel-order-cancel" onClick={() => null}>
                        <Text t="giveUp" />
                    </button>
                </div>
            ),
            className: 'warningModal-utts not-show-warning-buttons',
            okButtonProps: 'not-show-warning-buttons',
            onOk: async () => { },
            onCancel: async () => { },
        });
    };

    return (
        <>
            <CustomCollapseCard
                bodyCenter
                cardTitle={<Text t="cardTypeTitle" />}
                cardTitleAlign="center"
                titleColor="#1d2228"
                titleSize="18px"
                className="complimet-card-order-collapse "
                showExpandIcon={false}
            >
                <Radio.Group
                    id="ticketRestaurant-cardOrders-cardInformation-cardType-custom-radioGroup-input-content"
                    value={value}
                    className="custom-radio-input-content"
                >
                    <Radio
                        id="ticketRestaurant-cardOrders-cardInformation-cardType-custom-radio-input-content1"
                        value={1}
                        style={{
                            border: value === 1 ? '2px solid #1da483' : '2px solid #fff',
                            borderRadius: '8px',
                        }}
                    >
                        {currentCardOrder.cardType !== 0 ? (
                            <div
                                className="compliment-credit-card-item"
                                style={{ display: 'flex', flexDirection: 'row' }}
                            >
                                <div className="left-green-area">
                                    <CustomImage src={imgGreen} style={{ marginLeft: -5, height: 198 }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="compliment-credit-card-item-first-area">
                                        <h4 className="compliment-credit-card-item-text-head">
                                            <Text t="digitalCard" />
                                        </h4>
                                        <span className="compliment-credit-card-item-text-text">
                                            <Text t="createADigitalCardForAGreenerFuture" />
                                        </span>
                                    </div>
                                    <div className="card-info">
                                        <p>
                                            <Text t="cardNumberToYourEmployee" />{' '}
                                            <b>
                                                <Text t="smsOnTheSameDay" />
                                            </b>{' '}
                                            <Text t="isTransmittedViaYourEmployees" />{' '}
                                            <b>
                                                <Text t="addCardNumbersToTheMobileApplicationAnd" />
                                            </b>
                                        </p>
                                    </div>
                                </div>
                                <div style={{ position: 'absolute', right: 20, top: 20 }}>
                                    <CustomImage className={bankCardLogoClass1 && bankCardLogoClass1.className ? bankCardLogoClass1.className : ''} src={CardDigitalSrc} />
                                </div>
                            </div>
                        ) : (
                            <div
                                className="compliment-credit-card-item"
                                style={{ display: 'flex', flexDirection: 'row' }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="compliment-credit-card-item-first-area">
                                        <h4 className="compliment-credit-card-item-text-head">
                                            <Text t="classicCard" />
                                        </h4>
                                        <span
                                            className="compliment-credit-card-item-text-text"
                                            style={{ color: '#eb1000' }}
                                        >
                                            <Text t="physicalCardsCauseIrreversibleDamageToNature" />
                                        </span>
                                    </div>
                                    <div className="card-info">
                                        <p>
                                            <Text t="yourCardWillBeSentToYourAddress" />
                                            <br />
                                            <Text t="becomesActiveWhenYouGiveConfirmationForYour" />
                                        </p>
                                    </div>
                                </div>
                                <div style={{ position: 'absolute', right: -8, top: -4 }}>
                                    <CustomImage className={bankCardLogoClass2 || ''} src={fizikselImgSrc} />
                                </div>
                            </div>
                        )}
                    </Radio>
                    <div className="change-card-type">
                        {currentCardOrder.cardType === 0 ? <CustomImage src={npGreen} /> : null}

                        <button
                            type="button"
                            style={{ backgroundColor: 'transparent', borderWidth: 0 }}
                            onClick={clickChangeCard}
                        >
                            <p>
                                <Text t="or" />{' '}
                                {isEnglish && <b style={{ textDecoration: 'underline' }}>
                                    <Text t="continueWith" />
                                    {' '}
                                </b>}
                                <b style={{ textDecoration: 'underline', fontFamily: 'UbuntuBold, sans-serif' }}>
                                    {currentCardOrder.cardType === 0 ? <Text t="digital" /> : <Text t="physical" />} <Text t="card" />
                                </b>{' '}
                                {!isEnglish && <b style={{ textDecoration: 'underline' }}>
                                    {' '}
                                    <Text t="continueWith" />
                                </b>}
                            </p>
                        </button>

                        <Tooltip
                            overlayClassName="compliment-custom-tooltip"
                            title={
                                <div className="div-box">
                                    <span style={{ color: '#000', fontWeight: 'normal', fontSize: 13 }}>
                                        <Text t="yourCardWillBeSentToYourAddress2" />
                                    </span>
                                </div>
                            }
                            color="#646363"
                            placement="right"
                            arrowPointAtCenter={true}
                        >
                            {''}
                            <CustomImage src={iconInfo} style={{ cursor: 'pointer' }} />
                        </Tooltip>
                    </div>
                </Radio.Group>
            </CustomCollapseCard>

            <Modal
                visible={showFizikselCardModal}
                onCancel={() => setShowFizikselCardModal(false)}
                footer={null}
                centered
                closeIcon
                forceRender
                destroyOnClose
                className="compliment-modal"
                style={{ borderRadius: 10 }}
                bodyStyle={{
                    borderRadius: 10,
                    backgroundColor: 'transparent',
                    padding: 0,
                    overflow: 'hidden',
                }}
            >
                <button
                    type="button"
                    style={{
                        height: 300,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: '#E8F5E9',
                        cursor: 'pointer',
                        borderWidth: 0,
                        padding: 0,
                    }}
                >
                    <Lottie animationData={cardTypeAnimation} loop={true} />
                </button>
                <div
                    style={{
                        backgroundColor: '#124c40',
                        padding: '24px',
                        textAlign: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <h3 className="compliment-card-type-modal-title" style={{ width: 300, marginBottom: 16 }}>
                        <Text t="areYouSureYouWantToContinueWith" />
                    </h3>
                    <p className="compliment-card-type-modal-text" style={{ width: 400, marginBottom: 24 }}>
                        <Text t="youCanStillChooseADigitalCardYou" />
                    </p>

                    <div
                        style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                            marginBottom: 24,
                        }}
                    >
                        <button type="button" onClick={goOnDigital} className="compliment-card-type-modal-button1">
                            <Text t="continueWithDigitalCard" />
                        </button>
                        <button type="button" onClick={goToFizik} className="compliment-card-type-modal-button2">
                            <Text t="continueWithPhysicalCard" />
                        </button>
                    </div>

                    <button type="button" className="compliment-card-type-modal-dont-show" onClick={clickDontShow}>
                        <Text t="donTShowAgain" />
                    </button>
                </div>
            </Modal>
        </>
    );
};

CardType.propTypes = {
    vouId: PropTypes.number.isRequired,
    CardDigitalSrc: PropTypes.string,
    fizikselImgSrc: PropTypes.string,
    bankCardLogoClass1: PropTypes.object,
    bankCardLogoClass2: PropTypes.string,
};

export default CardType;
